import { getCurrentInstance } from '@/util';

export default function useToast() {
  const instance = getCurrentInstance();
  return { toast: instance.proxy.$toast };
}
